module.exports = __webpack_public_path__ + "img/pic1.338ebfe9.jpg";